import { DatadogEventProcessor } from ".";
import { redactSearchParams } from "../../redaction/redactSearchParams";

/** Redacts search param values from all editable URLs of a RUM event.
 * https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#modify-the-content-of-a-rum-event
 */
export const redactUrlSearchParams: DatadogEventProcessor = (event) => {
  event.view.url = redactSearchParams(event.view.url);

  if (event.view.referrer) {
    event.view.referrer = redactSearchParams(event.view.referrer);
  }

  if (event.type === "resource") {
    event.resource.url = redactSearchParams(event.resource.url);
  }

  if (event.type === "error" && event.error.resource?.url) {
    event.error.resource.url = redactSearchParams(event.error.resource.url);
  }
};
